import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl,FormGroup } from '@angular/forms';
import { ExamService } from 'src/app/core/exam.service';
import { Exam } from 'src/app/models/exam.model';

@Component({
  selector: 'app-exam-run',
  templateUrl: './exam-run.component.html',
  styleUrls: ['./exam-run.component.scss'],
  standalone: false
})
export class ExamRunComponent {

  @Input() exam!: Exam;
  @Output() examFinished: EventEmitter<Exam> = new EventEmitter<Exam>();
  
  questionIndex: number = 0;
  form?: FormGroup;

  isSavingExamQuestions: boolean = false;

  constructor(
    private fb: FormBuilder,
    private examService: ExamService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      userAnswer: ['', []],
    });

    this.form.get('userAnswer')?.valueChanges.subscribe(value => {
      this.exam.examQuestions[this.questionIndex].userAnswer = value;
    });
  }

  next() {
    if (this.questionIndex < this.exam.examQuestions.length - 1) {
      this.questionIndex++;
      this.form?.get('userAnswer')?.setValue(this.exam.examQuestions[this.questionIndex].userAnswer);
    } else {
      this.isSavingExamQuestions = true;
      this.examService.saveExamQuestions(this.exam.examQuestions).subscribe((result) => {
        this.isSavingExamQuestions = false;
        this.examFinished.emit(this.exam);
      });
    }
  }

  getControl(control: string) {
    return this.form!.get(control) as FormControl;
  }
}
